module.exports = __webpack_public_path__ + "static/media/Programci.6d279962.png";